<template >
    <div >
        <el-form   ref="lineForm" :model="tableData" label-width="110px" size="mini" >
            <el-form-item prop="name" class="lable-width" label="用户名" :rules="{required: true, message: '请输入用户名', trigger: 'blur'}">
                <el-input  class="input-width" placeholder="请输入用户名" clearable v-model="tableData.name" ></el-input>
            </el-form-item>
<!--            <el-form-item prop="phone" class="lable-width" label="手机号" :rules="{required: true, message: '请输入手机号', trigger: 'blur',pattern:/^1[3|5|7|8|9]\d{9}$/,message:'请输入正确的手机号'}">-->
                <el-form-item prop="phone" class="lable-width" label="手机号" >
                <el-input oninput="value=value.replace(/[^0-9]/g,'')" class="input-width" placeholder="请输入手机号" clearable v-model="tableData.phone" ></el-input>
            </el-form-item>
            <el-form-item prop="wxContact" class="lable-width" label="微信号" :rules="{required: true, message: '请输入微信号', trigger: 'blur'}">
                <el-input oninput="value=value.replace(/[\u4E00-\u9FA5 ]/g,'')" class="input-width" placeholder="请输入微信号" clearable v-model="tableData.wxContact" ></el-input>
            </el-form-item>
            <el-form-item prop="nfc" class="lable-width" label="NFC卡号" >
                <el-input oninput="value=value.replace(/[^a-zA-Z0-9]/g,'')" class="input-width" placeholder="请输入NFC卡号" clearable v-model="tableData.nfc" ></el-input>
            </el-form-item>
            <el-form-item  class="lable-width" label="授权应用" v-if="tableData.add==1">
                <el-select  clearable multiple class="input-width"
                            value-key="appId"
                           v-model="tableData.appList"
                           filterable
                           placeholder="请选择授权应用"
                >
                    <el-option
                            v-for="(item,index) in sqtypedata"
                            :key="index"
                            :label="item.name"
                            :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  label="类型">
                <div style="margin-left: 60px">
                    <el-radio v-model="tableData.type" label="1" disabled>内部</el-radio>
                    <el-radio v-model="tableData.type" label="2" disabled>外部</el-radio>
                </div>
            </el-form-item>
            <el-form-item  label="是否管理">
                <div style="margin-left: 60px">
                    <el-radio v-model="tableData.isAdmin" :label="0">否</el-radio>
                    <el-radio v-model="tableData.isAdmin" :label="1">是</el-radio>

                </div>
            </el-form-item>
            <el-form-item  label="状态">
                <div style="margin-left: 60px">
                    <el-radio v-model="tableData.state" :label="0">禁用</el-radio>
                    <el-radio v-model="tableData.state" :label="1">启用</el-radio>
                </div>
            </el-form-item>
            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit('lineForm')" :disabled="savebtn">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'addOuntSideUser',
        props:{
            editData:{
                type:Object
            },
            sqtypedata:{
                type:Array
            }
        },
        data(){
            return{
                savebtn:false,
                tableData:{},
                // sqtypedata:[],
            }
        },
        mounted(){
            this.tableData=JSON.parse(JSON.stringify(this.editData))
            if(this.tableData.wxContact==''){
                this.tableData.wxContact=this.tableData.phone
            }

                    if(this.tableData.appList.length>0){
                        this.sqtypedata.map(item=>{
                            this.tableData.appList.map(it=>{
                                if(item.appId==it.appId){
                                    item.id=it.id
                                }
                            })
                        })
                    }

        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onSubmit(lineForm){
                this.$refs[lineForm].validate(valid=>{
                    if(valid){
                        if(this.tableData.add==0){
                            this.addWxUser()
                        }else{
                            if(!this.savebtn){
                                this.updWxUser()
                            }
                        }
                    }
                })
            },
            close(){
                this.$emit('closedialog')
            },
            // async getAppList() {
            //     let result = await this.getCurrentMenuId({path: this.$route.path});
            //     if (result.i_id !== "") {
            //         this.mid = result.i_id
            //         sessionStorage.setItem('mids', result.i_id)
            //     } else {
            //         this.mid = sessionStorage.getItem('mids')
            //     }
            //     let params = {
            //         type:this.tableData.type
            //     }
            //     let res = await API.getAppList(params);
            //     if (res.code == 1) {
            //         this.sqtypedata=res.data
            //         if(this.tableData.appList.length>0){
            //             this.sqtypedata.map(item=>{
            //                 this.tableData.appList.map(it=>{
            //                     if(item.appId==it.appId){
            //                         item.id=it.id
            //                     }
            //                 })
            //             })
            //         }
            //
            //     } else if (res.code == -2) {
            //         this.savebtn = false
            //         this.$router.push('/login');
            //         this.$message.error(res.message);
            //     } else {
            //         this.savebtn = false
            //         this.$message.error(res.message);
            //     }
            // },
            async addWxUser(){
                this.savebtn=true
                // console.log(this.selectdata)

                let b=[]
                    b.push({
                        personId:0,
                        name:this.tableData.name,
                        phone:this.tableData.phone,
                        wxContact:this.tableData.wxContact,
                        nfc:this.tableData.nfc,
                        type:2,
                        isAdmin:this.tableData.isAdmin
                    })
                let param = {
                    list:b,
                    lruid:sessionStorage.getItem("userid"),
                    lruName:sessionStorage.getItem("lruname")
                };
                let res = await API.addWxUser(param);
                if (res.code == 1) {
                    this.savebtn=false
                    this.$message.success(res.message)
                    this.$emit('savesuccess')
                } else if (res.code == -2) {
                    this.savebtn=false

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.savebtn=false

                    this.$message.error(res.message);
                }
            },
            async updWxUser() {
                this.savebtn=true
                let a =JSON.parse(JSON.stringify(this.tableData))
                let b =JSON.parse(JSON.stringify(this.editData))
                a.appList.forEach(item=>{
                    b.appList.forEach(oitem=>{
                        if(item.appId==oitem.appId){
                            item.uid=oitem.uid
                        }
                    })
                })
                let c=[]
                for(let k in a){
                    for(let j in b){
                        if(k==j&&JSON.stringify(a[k])!=JSON.stringify(b[j])){
                            c.push(k)
                        }
                    }
                }
                if(c.length==0){
                    this.$message.warning('未进行数据修改');
                    // this.$emit('closedialog')
                    this.savebtn=false
                    return
                }
                let add=a.appList.filter(item=>!b.appList.some(item1=>item.appId==item1.appId))
                let del=b.appList.filter(item=>!a.appList.some(item1=>item1.appId==item.appId))
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.tableData.id,
                    name:this.tableData.name,
                    phone:this.tableData.phone,
                    wxContact:this.tableData.wxContact,
                    addAppList:add,
                    delAppList:del,
                    nfc:this.tableData.nfc,
                    state:this.tableData.state,
                    isAdmin:this.tableData.isAdmin,
                    lruid:this.tableData.lruid,
                    registerTime:this.tableData.registerTime,
                    mainTable:this.tableData.mainTable,
                    validateCode:this.tableData.validateCode,
                    validateKeynames:this.tableData.validateKeynames
                }
                let res = await API.updWxUser(params);
                if (res.code == 1) {

                    this.$message.success(res.message);

                    this.$emit("savesuccess")
                    setTimeout(()=>{
                        this.savebtn = false
                    },1000)
                } else if (res.code == -2) {
                    this.savebtn = false
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.savebtn = false
                    this.$message.error(res.message);
                }
            },


        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .upload-box img{
        width: 80px !important;
        height: 80px !important;
    }
    .lable-width{
        text-align: center;
    }
    .flexjcenter{
        display: flex;
        justify-content: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 15.571rem;
    }
    /*11111111111*/
    .mrr2{
        margin-right: 2px;
    }
    .img-box{
        /*border: 1px solid red;*/
        .uploadPhone{
            width: 70px;
            height: 80px;
            position: relative;
            width: 100px;
            padding-left: 50px;
            /*border: 1px solid cornflowerblue;*/
        }
        .uploadPhone .img{
            width: 80px;
            height: 80px;
            margin-right: 5px;
        }
        .elimg{
            width:105px
        }
        .el-icon-delete{
            padding-right: 5px;
        }


        .upload-box{
            /*background: red;*/
            width: 100%;
            height: 100%;
        }
        .upload-input{
            position: absolute;
            opacity: 0;
            width: 80px;
            height: 80px;
        }
    }
    .flex{
        display: flex;
    }
    .flex1{
        display: flex;
    }
    /*1111111111*/
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }

    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
    /deep/.el-form-item--mini.el-form-item,.el-form-item--small.el-form-item{
        margin-bottom:22px !important;
    }
</style>